<template>
  <div class="groups_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="name"
      ref="table"
      pagination-simple
      per-page="15"
      :data="groupsList"
      paginated
      checkable
      :checked-rows.sync="rows.checked"
      @page-change="changePage"
      @sort="initSort"
      backend-sorting
      backend-pagination
      :total="totalCount"
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props">
        <b-table-column label="Номер" :visible="true" field="name" :centered="false" sortable width="10%">
          <div>{{ props.row.id }}</div>
        </b-table-column>
        <b-table-column label="Название" :visible="true" field="name" :centered="false" sortable width="55%">
          <div>{{ props.row.name || '-' }}</div>
        </b-table-column>
        <b-table-column label="Дата создания" :visible="true" field="created_at" :centered="false" sortable width="30%">
          <div>{{ props.row.created_at | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button class="delete_course" @click="$emit('delete', props.row.id)">
            <i class="mdi mdi-folder-remove-outline"></i> Удалить
          </button>
          <button class="double_course" v-if="!props.row.deleted_at" @click="openGroupEdit(props.row)">
            <router-link :to="'/groups/' + props.row.id">
              <i class="mdi mdi-folder-open-outline"></i> Редактировать/смотреть группу
            </router-link>
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    groupsList: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    },
    totalCount: {
      default: () => 0,
      type: Number
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.$emit('init-sort', fieldName, sortType)
    },
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    },
    changePage(val) {
      this.$emit('changePage', val)
    },
    openGroupEdit(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/groups/' + val.id)
      }
    }
  }
}
</script>
